@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row.discount_type == 'Percentage') {
    <div>
      <i class="fa fa-percentage text-600"></i>
    </div>
  }
  @if ($.row.discount_type == 'Value') {
    <div><i class="fa fa-dollar text-600"></i></div>
  }
}
